<template>
    <div class="par_wrap">
        <p class="back_box" @click="back()">
          <img src="../../../static/images/back.png" alt="">
          返回上一页</p>
        <div class="box">
            <h2>查看并操作1</h2>
            <ParheaderVue :caseid="caseid" :token="token"/>
            <Parinf></Parinf>
        </div>
    </div>
</template>

<script>
import "isomorphic-fetch";
import constants from '@/util/constants.js';
import Promise from 'promise-polyfill';
import ParheaderVue from "../par/parheader.vue";
import Parinf from "../par/Parinf.vue";
export default {
  components: {
    ParheaderVue,
    Parinf
  },
  data() {
    return {
      token:JSON.parse(window.localStorage.getItem("data")).data,
      obj: {},
      victimList: {},
      inf: null,
      init: null,
      obj2: null,
      typeId:this.$route.query.typeId,
      caseid:this.$route.query.caseid,
      backto:this.$route.query.backto
    };
  },
  methods: {
    timestampToTime(timestamp) {
      if (timestamp) {
        var date = new Date(timestamp);
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D = date.getDate() + " ";
        var h = date.getHours() + ":";
        var m = date.getMinutes() + ":";
        var s = date.getSeconds();
        return Y + M + D + h + m + s;
      } else {
        return "";
      }
    },
    back() {
      let that = this;

      let r = "ComOffer";
      if(this.backto !=null && this.backto == '0'){
        r = "ComAwait";
      }
      console.log("backto :"+this.backto+" r:"+r);
      this.$router.push({
        name: r,
        params: {
          token: that.token
        },
        query: {
          typeId:this.typeId
        }
      });
    },
    up(v) {
      console.log(v);
    }
  }
};
</script>

<style scoped>
@import url(../../css/par.css);
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/Par.vue